module.exports = __webpack_public_path__ + "static/media/carpenter.1717d113.png";